import { Card, Layout, Row, Tabs } from 'antd'
import EmailList from 'components/Main/Emails/EmailList'
import EmailAddressList from 'components/Main/Newsletter/EmailAddressList'
import NewsletterList from 'components/Main/Newsletter/NewsletterList'
import TemplatesList from 'components/Main/Newsletter/TemplatesList'
import useFetch from 'elements/Hooks/useFetch'
import CustomBreadCrumb from '../../../components/Common/CustomBreadCrumb'
import PageTitle from '../../../elements/PageTitle'
import React, { Fragment } from 'react'

const { Content } = Layout

function Newsletter(props) {
  return (
    <Fragment>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <CustomBreadCrumb items={[{ text: 'Newsletter Campaign' }]} />
            <PageTitle
              title={'Newsletter Campaign'}
              subtitle={'Manage Your Newsletter Campaign.'}
              color={'#FF6138'}
              iconType={'shopping-cart'}
            />
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <Card>
            <Tabs defaultActiveKey="Campaign">
              <Tabs.TabPane tab="Campaign" key="Campaign">
                <NewsletterList {...props} />
              </Tabs.TabPane>
              <Tabs.TabPane tab="Email Address" key="Email Address">
                <EmailAddressList />
              </Tabs.TabPane>
              <Tabs.TabPane tab="Email Lists" key="Email List">
                <EmailList />
              </Tabs.TabPane>
              <Tabs.TabPane tab="Templates" key="Templates">
                <TemplatesList />
              </Tabs.TabPane>
            </Tabs>
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

Newsletter.propTypes = {}
Newsletter.defaultProps = {}

export default Newsletter
